export enum SubscriptionMode {
  MONTHLY = 'MONTHLY',
  ANNUALLY = 'ANNUALLY',
}
